module.exports = __webpack_public_path__ + "img/amx-16.29a9b462.jpg";